import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

type Props = {
  jobTitle: string;
};

export const JobApplicationPageTitle: React.VFC<Props> = ({ jobTitle }) => {
  const intl = useIntl();
  return jobTitle ? (
    <Helmet
      title={`${intl.formatMessage(
        { id: 'JOB_TITLE_TAG_SHOW_POSTING_DETAIL' },
        { job_title: jobTitle }
      )} | ${intl.formatMessage({ id: 'JOB_TITLEBAR_SUFFIX' })}`}
    />
  ) : null;
};
